import { createAsyncThunk } from '@reduxjs/toolkit';
import labApi from '../../core/api/lab.api';
import { ListShipmentsResponse } from '../../core/api/lab.types';

export const listShipmentsThunk = createAsyncThunk('shipment/listShipments', async (_, { rejectWithValue }: any) => {
  const response: ListShipmentsResponse = await labApi.listShipments();

  if (response.data?.listShipments) {
    return response.data.listShipments;
  }

  return rejectWithValue(response.errors);
});
